import './CRUDVendor.scss';
import Component from './CRUDVendor.js';
export default Component;
